import React from 'react';
import PropTypes from 'prop-types';

import {screenSizeSmaller} from 'views/components';

import MDEditor, {commands} from '@uiw/react-md-editor';
import localStorageTtl from 'utils/storage/local_storage_ttl';

const MarkdownEditor = (props) => {
  const smallSizeDown = screenSizeSmaller('sm');
  let cmds = [
    commands.bold, commands.italic, commands.strikethrough, commands.link, commands.divider,
    commands.unorderedListCommand, commands.orderedListCommand, commands.checkedListCommand, commands.divider,
    commands.code, commands.quote, commands.hr, commands.image, commands.divider,
  ];
  if (smallSizeDown) {
    cmds = [
      commands.bold, commands.italic, commands.strikethrough, commands.link,
      commands.unorderedListCommand, commands.orderedListCommand, commands.checkedListCommand,
      commands.code, commands.quote,
    ];
  }

  return (
    <React.Fragment>
      <MDEditor
        commands={cmds}
        value={props.value}
        onChange={props.onChange}
        preview={'edit'}
        autoFocus={props.autoFocus}
        onBlur={props.onBlur}
        height={props.height}
        data-id={props.id}
        textareaProps={{
          onKeyDown: props.onKeyDown,
          onKeyUp: props.onKeyUp,
        }}
      />
    </React.Fragment>
  );
};
MarkdownEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  onBlur: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  height: PropTypes.number,
  id: PropTypes.string,
};

const MarkdownEditorWithAutosave = (props) => {
  const [reload, setReload] = React.useState(false);
  const [savedOnce, setSavedOnce] = React.useState(false);

  const value = props.value;
  const onChange = props.onChange;
  const saveStringKey = props.saveString;
  const autoFocus = props.autoFocus;
  const onKeyDown = props.onKeyDown;
  const onKeyUp = props.onKeyUp;

  React.useEffect(() => {
    const comment = localStorageTtl.get(saveStringKey);
    if (comment) {
      onChange(comment);
    }
  }, [saveStringKey]);

  React.useEffect(() => {
    if (reload) {
      setReload(false);
      if (savedOnce && !value) {
        localStorageTtl.delete(saveStringKey);
      } else if (value) {
        setSavedOnce(true);
        localStorageTtl.set(saveStringKey, value, 604800000); // 7 Days
      }
    }
  }, [reload, value, saveStringKey, savedOnce]);

  const [debouncedSave] = React.useState(() => _.debounce(() => setReload(true), 500));

  React.useEffect(() => {
    debouncedSave();
  }, [value]);

  return (
    <MarkdownEditor
      value={value}
      onChange={onChange}
      autoFocus={autoFocus}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
    />
  );
};
MarkdownEditorWithAutosave.propTypes = {
  value: PropTypes.string,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  saveString: PropTypes.string.isRequired,
};


export {MarkdownEditor, MarkdownEditorWithAutosave};
